import styles from './MeSection.module.css';
import Button from '../Button/Button';

interface MeSectionProps {
	scroll: () => void;
}

const MeSection = ({ scroll }: MeSectionProps) => {
	return (
		<section className={styles.section} id="me">
			<p className={styles.command}>$whoami</p>
			<h1 className={styles.name}>Christoffer Mellem</h1>
			<p className={styles.title}>Frontend Developer</p>
			<div className={styles.buttonWrapper}>
				<Button className="viewButton" onClick={scroll}>
					View my work
				</Button>
			</div>
		</section>
	);
};

export default MeSection;
